import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BdcWalkModule } from 'bdc-walkthrough';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

import { PageWithTitleComponent } from './page-with-title.component';

@NgModule({
	imports: [
		CommonModule,
		MenuModule,
		TranslateModule.forChild(),
		ButtonModule,
		BdcWalkModule,
	],
	declarations: [PageWithTitleComponent],
	exports: [PageWithTitleComponent],
})
export class PageWithTitleModule {}
